import type { JSONContent } from "@tiptap/core";
import { renderToHTMLString } from "@tiptap/static-renderer";
import { htmlToText } from "html-to-text";
import { getExtensionList } from "./Extensions";

export function extractSimpleText({ content }: { content: JSONContent }) {
  const htmlString = renderToHTMLString({ content, extensions: getExtensionList("form") });
  console.log(htmlString);
  const simplifiedText = htmlToText(htmlString);
  console.log(simplifiedText);

  return simplifiedText;
}
